export interface Column {
  id: "email" | "username" | "first_name" | "last_name";
  label: string;
  minWidth?: number;
  align?: "left" | "center" | "right";
  format?: (value: number) => string;
}

export const columns: readonly Column[] = [
  { id: "email", label: "email", minWidth: 150, align: "center" },
  { id: "username", label: "username", minWidth: 150, align: "center" },
  { id: "last_name", label: "last_name", minWidth: 150, align: "center" },
  { id: "first_name", label: "first_name", minWidth: 150, align: "center" }
];
